function updateActivePagination(index) {
  var buttons = document.querySelectorAll('.custom-pagination-button');

  buttons.forEach(function (button, idx) {
    if (idx === index) {
      button.classList.add('is-active');
    } else {
      button.classList.remove('is-active');
    }
  });
}

function setupCustomPagination(splide) {
  const buttons = document.querySelectorAll('.custom-pagination-button');

  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      const index = parseInt(this.dataset.index);
      splide.go(index);
    });
  });

  // Set the first button as active
  updateActivePagination(0);
}

document.addEventListener('DOMContentLoaded', function () {
  const homeSlider = document.getElementById('homeSlider');
  const lastArticlesSlider = document.getElementById('lastArticles__slider');
  const teamMembers = document.getElementById('team-presentation');
  if(lastArticlesSlider) {
    const splideArticles = new Splide(lastArticlesSlider, {
      type: 'loop',
      perPage: 3,
      perMove: 1,
      gap: '50px',
      omitEnd: true,
      updateOnMove: true,
      autoplay: true,
      interval: 5000,
      pagination: false,
      arrows: true,
      lazyLoad: 'sequential',
      padding: { right: '15%' },
      breakpoints: {
        640: {
          perPage: 1,
          gap: '20px',
          padding: { right: '20%' },
        },
      },
    });
    const bar = splideArticles.root.querySelector( '.my-slider-progress-bar' );
    splideArticles.on( 'mounted move', function () {
      const end  = splideArticles.Components.Controller.getEnd() + 1;
      const rate = Math.min( ( splideArticles.index + 1 ) / end, 1 );
      bar.style.width = String( 100 * rate ) + '%';
    } );
    splideArticles.mount();
  }


  if(homeSlider){
    const splideHomeSlider = new Splide(homeSlider, {
      type   : 'loop',
      drag   : 'free',
      focus  : 'center',
      perPage: 3,
      pagination: false,
      arrows: false,
      autoScroll: {
        speed: 6,
      },
      breakpoints: {
        640: {
          autoScroll: {
            speed: 3,
          },
        },
      },
    });
    splideHomeSlider.mount(window.splide.Extensions);
  }

  // Events sliders initialization with conditional activation
  window.initializeEventSlider = function(slider) {
    if (!slider) return;

    const container = slider.closest('.events-slider-container');
    const navControls = container.querySelector('.splide-nav');
    const slideCount = slider.querySelectorAll('.splide__slide').length;
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 1024;
    const shouldActivateSplide = isMobile ? slideCount > 1 : slideCount > 4;

    // Destroy existing Splide instance if any
    if (slider.splide) {
      slider.splide.destroy();
    }

    if (shouldActivateSplide) {
      // Activate Splide
      slider.classList.remove('events-slider--static');

      const splideInstance = new Splide(slider, {
        type: 'loop',
        perPage: 3,
        perMove: 1,
        gap: '30px',
        pagination: false,
        arrows: false,
        breakpoints: {
          640: { perPage: 1, gap: '20px' },
          1024: { perPage: 2, gap: '25px' },
        },
      });

      splideInstance.mount();
      slider.splide = splideInstance;

      // Show and setup navigation controls
      if (navControls) {
        navControls.style.display = 'flex';

        const prevButton = container.querySelector('.splide-nav__prev');
        const nextButton = container.querySelector('.splide-nav__next');

        if (prevButton) {
          prevButton.onclick = function() { splideInstance.go('<'); };
        }
        if (nextButton) {
          nextButton.onclick = function() { splideInstance.go('>'); };
        }
      }
    } else {
      // Static grid mode
      slider.classList.add('events-slider--static');
      if (navControls) {
        navControls.style.display = 'none';
      }
    }
  };

  // Initialize all visible sliders on load
  const eventsSliders = document.querySelectorAll('.events-slider');
  eventsSliders.forEach(function(slider) {
    const section = slider.closest('.events-category-section');
    if (section && !section.classList.contains('is-hidden')) {
      window.initializeEventSlider(slider);
    }
  });

  // Reinitialize on window resize (debounced)
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      eventsSliders.forEach(function(slider) {
        const section = slider.closest('.events-category-section');
        if (section && !section.classList.contains('is-hidden')) {
          window.initializeEventSlider(slider);
        }
      });
    }, 250);
  });

});